/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CloseIsolatedPositionOptions,
  CloseIsolatedPositionResponses,
} from '../types/CloseIsolatedPosition'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Close isolated positions, repaying the borrowed
 * {@link /v1/positions/close}
 */
export function closeIsolatedPosition<ThrowOnError extends boolean = true>(
  options: Options<CloseIsolatedPositionOptions, ThrowOnError>,
): Unwrappable<RequestResult<CloseIsolatedPositionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/positions/close',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CloseIsolatedPositionResponses, ThrowOnError>>,
  )
}
